
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/hub/templates/layout"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='hub-headerRegion'></div>\n<div class='hub-loaderRegion'></div>\n<div class='hub-smartScrollComponentRegion'\n     aria-label='Chat and Activity'\n     role='log'></div>\n<div class='hub-composeComponentRegion'></div>\n";
},"useData":true});
    }).call(this);
  